module.exports = __webpack_public_path__ + "img/DESTAQUE-430x590px.1810ad6a.png";